"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MessageLayout = exports.MessageLayoutSidebar = void 0;

var React = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ = require("../..");

var _helpers = require("../../helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var FixedPanel = (0, _styledComponents.default)(_.Card).attrs({
  spacing: 'none',
  elevation: 'flat'
}).withConfig({
  displayName: "FixedPanel",
  componentId: "xvhbz-0"
})(["margin-top:0;@media ", "{border-radius:0;border-width:0 0 1px;}@media ", "{position:fixed;overflow:visible;overflow-x:scroll;margin:0;top:144px;bottom:0px;width:320px;border-radius:0 0 0 4px;}"], (0, _helpers.breakpoint)('maxTablet'), (0, _helpers.breakpoint)('minDesktop'));
var FixedPanelTitle = (0, _styledComponents.default)(_.Card).attrs({
  elevation: 'flat'
}).withConfig({
  displayName: "FixedPanelTitle",
  componentId: "xvhbz-1"
})(["font-size:1rem;line-height:1.5rem;font-weight:", ";@media ", "{border-radius:4px 4px 0 0;border-width:0 0 1px 0;margin:0;}@media ", "{position:fixed;top:80px;width:320px;color:", ";padding:", ";font-size:1.25rem;line-height:2rem;border-radius:4px 0 0 0;}"], (0, _helpers.fontWeight)('medium'), (0, _helpers.breakpoint)('maxTablet'), (0, _helpers.breakpoint)('minDesktop'), (0, _helpers.color)('black'), (0, _helpers.getSpacing)('medium'));

var MessageLayoutSidebar = function MessageLayoutSidebar(_ref) {
  var children = _ref.children,
      title = _ref.title;
  return React.createElement(_.Aside, null, title && React.createElement(FixedPanelTitle, null, title), children && React.createElement(FixedPanel, null, children));
};

exports.MessageLayoutSidebar = MessageLayoutSidebar;
var MessageLayout = (0, _styledComponents.default)(_.Section).withConfig({
  displayName: "MessageLayout",
  componentId: "xvhbz-2"
})(["@media ", "{margin:0 -16px;}@media ", "{", "{margin-left:0;float:left;overflow:hidden;}", "{float:right;width:689px;min-height:calc(100vh - 56px);margin-top:24px;margin-left:-1px;border:1.4px solid ", ";border-width:0 1.4px 1.4px;border-radius:0 4px 4px 0;}}"], (0, _helpers.breakpoint)('maxTablet'), (0, _helpers.breakpoint)('minDesktop'), _.Aside, _.Content, (0, _helpers.color)('dark-3'));
exports.MessageLayout = MessageLayout;